/**
 * `/people/:slug` — one credited person.
 *
 * One `RouteObject`, so the file takes the SINGULAR name; an aggregate array
 * would be `people.routes.tsx`, and the importer knows the shape from the name.
 *
 * The param is the **slug**, matching the public site's own URL contract for
 * this surface — a reader who has an address from either host can paste it into
 * the other. Slugs here are Arabic prose, which is fine on a static SPA host:
 * the history fallback serves `index.html` for any path, and React Router
 * decodes the segment before the page ever sees it. (`frontend-landing` needs a
 * decoder of its own; this host does not.)
 *
 * The route resolves nothing and fetches nothing: **no `loader` in this repo
 * performs a data read.** The page component owns its reads.
 */
import type { RouteObject } from 'react-router-dom';

export const peopleRoute: RouteObject = {
  path: 'people/:slug',
  lazy: async () => {
    const { PeoplePage } = await import('./PeoplePage');
    return { Component: PeoplePage };
  },
};
